import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Hero from "./components/sections/Hero";
import Confession from "./components/sections/Confession";
import SafetyProblem from "./components/sections/SafetyProblem";
import CostProblem from "./components/sections/CostProblem";
import Reveal from "./components/sections/Reveal";
import Comparison from "./components/sections/Comparison";
import VideoSection from "./components/sections/VideoSection";
import BigCTA from "./components/sections/BigCTA";
import SiteFooter from "./components/sections/SiteFooter";

const Campaign = () => {
  return (
    <main data-testid="campaign-page" className="relative bg-[#0F0F0F] text-[#E8E5DE]">
      <div className="grain-overlay" aria-hidden />
      <Hero />
      <Confession />
      <SafetyProblem />
      <CostProblem />
      <Reveal />
      <Comparison />
      <VideoSection />
      <BigCTA />
      <SiteFooter />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Campaign />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
